import BlogAudioLayoutContainer from "../../../../components/pages/blog/blogDetail/BlogAudioLayout";

const BlogAudioLayout = () => {
  return <BlogAudioLayoutContainer />;
};

export default BlogAudioLayout;
